import styled from '@emotion/styled';
import { css, SerializedStyles } from '@emotion/react';
import tw from 'twin.macro';

const IconProps = (spin?: boolean): string => `
  color: inherit;
  ${spin ? 'animation: icon-loading 2s linear infinite;' : ''}
`;

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const icon = (c: any, zoom?: number, css?: SerializedStyles) => {
  return styled(c)`
    height: auto;
    ${zoom ? `transform : scale(${zoom});` : ''} ${({ spin }): string => IconProps(spin)}
      ${css};
  `;
};

export const ClearIcon: React.FC<{ className?: string }> = ({ className }) => (
  <i className={`icon close ${className}`} />
);

import { ReactComponent as dotsIcon } from '$/images/dots.svg';
export const DotsIcon = icon(dotsIcon);

import { ReactComponent as check } from '$/images/checked-icon.svg';
export const CheckIcon = icon(check);

import { ReactComponent as error } from '$/images/error.svg';
export const ErrorIcon = icon(error, 1.2);

import { ReactComponent as close } from '$/images/close.svg';
export const CloseIcon = icon(close);

import { ReactComponent as spinner } from '$/images/spinner.svg';
export const Spinner = icon(
  spinner,
  1,
  css`
    animation: icon-loading 2s linear infinite;
    max-height: 30px;
    max-width: 30px;
  `
);
import { ReactComponent as uploadIcon } from '$/images/upload-rounded.svg';
export const UploadIcon = icon(uploadIcon);

import { ReactComponent as zoomIcon } from '$/images/zoom-rounded.svg';
export const ZoomIcon = icon(zoomIcon);

import { ReactComponent as interaction } from '$/images/interaction.svg';
export const InteractionIcon = icon(interaction);

import { ReactComponent as registrant } from '$/images/registrationrate.svg';
export const RegistrantIcon = icon(registrant);

import { ReactComponent as add } from '$/images/add.svg';
export const AddIcon = icon(add, 0.9);
import { ReactComponent as fb } from '$/images/facebook.svg';
export const FacebookIcon = icon(fb);

import { ReactComponent as twitter } from '$/images/twitter.svg';
export const TwitterIcon = icon(twitter);

import { ReactComponent as instagram } from '$/images/instagram.svg';
export const InstagramIcon = icon(instagram);

import { ReactComponent as replay } from '$/images/replay.svg';
export const ReplayIcon = icon(replay);

import { ReactComponent as linkedin } from '$/images/linkedin.svg';
export const LinkedInIcon = icon(
  linkedin,
  undefined,
  css`
    color: #0e76a8;
  `
);

import { ReactComponent as avatar } from '$/images/avatar.svg';
export const Avatar = icon(avatar);

import { ReactComponent as edit } from '$/images/pencil.svg';
export const EditIcon = icon(edit);

import { ReactComponent as editcard } from '$/images/edit.svg';
export const EditCardIcon = icon(editcard);

import { ReactComponent as publish } from '$/images/publish.svg';
export const PublishIcon = icon(
  publish,
  1,
  css`
    position: relative;
    top: 2px;
  `
);

import { ReactComponent as backarrow } from '$/images/backArrow.svg';
export const BackArrowIcon = icon(
  backarrow,
  undefined,
  css`
    color: #7c8a8d;
  `
);

import { ReactComponent as downarrow } from '$/images/arrowDown100.svg';
export const DownArrowIcon = icon(downarrow);

import { ReactComponent as downLongArrow } from '$/images/longArrowDown.svg';
export const DownLongArrowIcon = icon(downLongArrow);

import { ReactComponent as righarrow } from '$/images/arrowRight.svg';
export const MoreToRightIcon = icon(
  righarrow,
  undefined,
  css`
    color: #7c8a8d;
  `
);

import { ReactComponent as chrome } from '$/images/chrome.svg';
export const ChromeIcon = icon(chrome);

import { ReactComponent as safari } from '$/images/safari.svg';
export const SafariIcon = icon(safari);

import { ReactComponent as edge } from '$/images/edge.svg';
export const EdgeIcon = icon(edge);

import { ReactComponent as firefox } from '$/images/firefox.svg';
export const FirefoxIcon = icon(firefox);

import { ReactComponent as refresh } from '$/images/refresh.svg';
export const RefreshIcon = icon(refresh);
import { ReactComponent as registrationRateIcon } from '$/images/registrationrate.svg';
export const RegistrationRateIcon = icon(registrationRateIcon);
import { ReactComponent as plusIcon } from '$/images/plus.svg';
export const PlusIcon = icon(plusIcon);

import { ReactComponent as code } from '$/images/code.svg';
export const CodeIcon = icon(code, 0.9);

import { ReactComponent as votesup } from '$/images/votesup.svg';
export const VotesUpIcon = icon(votesup);

import { ReactComponent as copy } from '$/images/copy.svg';
export const CopyIcon = icon(copy, 1);

import { ReactComponent as picture } from '$/images/picture.svg';
export const PictureIcon = icon(picture);

import { ReactComponent as attendees } from '$/images/attendees.svg';
export const AttendeesIcon = icon(
  attendees,
  1,
  css`
    width: auto;
    height: auto;
  `
);

import { ReactComponent as watchedPercent } from '$/images/watchedPercent.svg';
export const WatchedPercentIcon = icon(
  watchedPercent,
  1,
  css`
    width: auto;
    height: auto;
  `
);

import { ReactComponent as imageWithText } from '$/images/imageWithText.svg';
export const ImageLeftTextRightIcon = icon(imageWithText);

import { ReactComponent as imageBackground } from '$/images/imageBackground.svg';
export const ImageBackgroundRightIcon = icon(imageBackground);

import { ReactComponent as logoAndTeaser } from '$/images/logoAndTeaser.svg';
export const LogoAndTeaserIcon = icon(logoAndTeaser);

export const ImageRightTextLeftIcon = icon(
  imageWithText,
  1,
  css`
    transform: scaleX(-1);
  `
);

import { ReactComponent as sessions } from '$/images/sessions.svg';
export const SessionsIcon = icon(
  sessions,
  1,
  css`
    width: auto;
    height: auto;
  `
);

import { ReactComponent as presentersSection } from '$/images/presenters-section.svg';
export const PresentersSectionIcon = icon(presentersSection);

import { ReactComponent as testimonialsSection } from '$/images/testimonials-section.svg';
export const TestimonialsSectionIcon = icon(testimonialsSection);

import { ReactComponent as trash } from '$/images/trash.svg';
export const TrashIcon = icon(
  trash,
  undefined,
  css`
    ${tw`text-color-delete! h-1e`}
  `
);
export const DeleteIcon = icon(
  trash,
  undefined,
  css`
    ${tw`text-color-delete! h-1e`}
  `
);

import { ReactComponent as DragHandle } from '$/images/drag-handle.svg';
export const DragHandleIcon = icon(DragHandle);

import { ReactComponent as arrowNext } from '$/images/arrowNext.svg';
export const NextArrowIcon = icon(arrowNext);

import { ReactComponent as back } from '$/images/back.svg';
export const BackIcon = icon(back);

import { ReactComponent as newMsgIcon } from '$/images/newMsgIcon.svg';
export const NewMsgIcon = icon(newMsgIcon);

import { ReactComponent as buttonIcon } from '$/images/buttonIcon.svg';
import React from 'react';
export const CTAButtonIcon = icon(buttonIcon);

import { ReactComponent as bb } from '$/images/logos/bombbomb.svg';
export const BombBombIcon = icon(bb, 1);

import { ReactComponent as webinarIcon } from '$/images/webinarIcon.svg';
export const eWebinarIcon = icon(webinarIcon);

import { ReactComponent as thumbsup } from '$/images/thumbsUp.svg';
export const ThumbsUpIcon = icon(thumbsup);

import { ReactComponent as pause } from '$/images/pause.svg';
export const PauseIcon = icon(pause);

import { ReactComponent as playButton } from '$/images/playButton.svg';
export const PlayButtonIcon = icon(playButton, undefined, css``);

import { ReactComponent as pauseButton } from '$/images/pauseButton.svg';
export const PauseButtonIcon = icon(pauseButton, undefined, css``);

import { ReactComponent as play } from '$/images/play.svg';
export const PlayIcon = icon(play);

export const ArrowRightIcon = icon(play);
import { ReactComponent as playLeft } from '$/images/playLeft.svg';
export const ArrowLeftIcon = icon(playLeft);

import { ReactComponent as iorad } from '$/images/logos/iorad.svg';
export const IoradIcon = icon(iorad);

import { ReactComponent as eyesolid } from '$/images/eye-solid.svg';
export const EyeSolid = icon(eyesolid);
